module.exports = __webpack_public_path__ + "img/img-services-ecommerce.686ea29d.png";